import i18n from "i18n";

export const handleShowTerms = (accessConditions, swal) => {
    let span = document.createElement("span");
    span.innerHTML = `<div class="text-left">${accessConditions}</div>`;
    swal({
        title: i18n.t("terms & conditions"),
        content: span,
        className: "w-full",
        buttons: {
            cancel: i18n.t("close"),
        },
    });

    scrollModalToTop();
    return false;
};

export const handleShowPrivacy = (privacyPolicy, swal) => {
    let span = document.createElement("span");
    span.innerHTML = '<div class="text-left">' + privacyPolicy + "</div>";
    swal({
        title: i18n.t("privacy policy"),
        content: span,
        className: "w-full",
        buttons: {
            cancel: i18n.t("close"),
        },
    });
    scrollModalToTop();
    return false;
};

const scrollModalToTop = () => setTimeout(() => {
    const modal = document.querySelector(".swal-modal");
    if (modal) {
        modal.style.overflowY = "auto";
        modal.scrollTop = 0;
        modal.style.maxHeight = "80vh";
    }
}, 100);